import { Button, Flex, Text, VStack } from '@chakra-ui/react';
import { NoteTemplate } from '@web-app/components/ChartingNoteEditor/types';
import { FC } from 'react';
import { FiPlus } from 'react-icons/fi';

interface TemplateSelectorProps {
  templates: NoteTemplate[];
  onTemplateSelect: (templateTitle: string) => void;
  onStartNewNote: () => void;
  testIdPrefix?: string; // For test IDs (e.g., 'template-' or 'tiptap-template-')
  startNewNoteTestId?: string; // For start new note button test ID
}

/**
 * Reusable template selector component
 * Displays a list of templates and a "Start from scratch" option
 * Used by ChartingNoteEditor and TipTapTab
 */
export const TemplateSelector: FC<TemplateSelectorProps> = ({
  templates,
  onTemplateSelect,
  onStartNewNote,
  testIdPrefix = 'template-',
  startNewNoteTestId = 'start-new-note',
}) => {
  return (
    <VStack alignItems="start" spacing={3} data-testid="template-selector">
      <Text fontWeight="600" mb={2}>
        Start from a template:
      </Text>
      {templates.map((template) => (
        <Button
          width="100%"
          size="lg"
          justifyContent="start"
          variant="outline"
          colorScheme="green"
          key={template.title}
          onClick={() => onTemplateSelect(template.title)}
          data-testid={`${testIdPrefix}${template.title}`}
        >
          <Flex justifyContent="space-between" alignItems="center" width="100%">
            <Text fontWeight="600">{template.title}</Text>
            <FiPlus />
          </Flex>
        </Button>
      ))}
      <Text fontWeight="600" mt={4} mb={2}>
        Or start from scratch:
      </Text>
      <Button
        width="100%"
        size="lg"
        justifyContent="start"
        variant="outline"
        colorScheme="green"
        onClick={onStartNewNote}
        data-testid={startNewNoteTestId}
      >
        <Flex justifyContent="space-between" alignItems="center" width="100%">
          <Text fontSize="md">Start a new note</Text>
          <FiPlus />
        </Flex>
      </Button>
    </VStack>
  );
};
